<template>
    <el-row>
        <el-col>
            <div class="card-deal-finance" v-loading="loading">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
                <div style="margin-top: 1rem">
                    <el-button class="spreadsheet-header-button" type="warning" @click="createCashIncome" v-if="canCreateCashIncome">
                        новый приход @
                    </el-button>
                    <el-button class="spreadsheet-header-button" type="warning" @click="createCashLessIncome" v-if="canCreateCashLessIncome">
                        новый приход безнал
                    </el-button>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import '@/assets/styles/list.scss';
import '@/assets/styles/card-complex.scss';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'Income',
    data() {
        return {
            localReferences,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            loading: false,
            data: {}
        };
    },
    components: {
        'ag-grid-vue': AgGridVue
    },
    props: {
        dealId: {
            type: [String, Number],
            default: 0
        }
    },
    computed: {
        incomes() {
            return this.$store.state.incomes.incomes;
        },
        isIncomeCashEmployer() {
            return this.$store.getters.isIncomeCashEmployer;
        },
        isIncomeCashDirector() {
            return this.$store.getters.isIncomeCashDirector;
        },
        isIncomeCashLessAccountant() {
            return this.$store.getters.isIncomeCashLessAccountant;
        },
        isIncomesCashLessEmployer() {
            return this.$store.getters.isIncomesCashLessEmployer;
        },
        canCreateCashIncome() {
            return this.isIncomeCashEmployer || this.isIncomeCashDirector;
        },
        canCreateCashLessIncome() {
            return this.isIncomesCashLessEmployer || this.isIncomeCashLessAccountant;
        }
    },
    created() {
        this.columnDefs = [
            { headerName: 'id', field: 'id', cellRenderer: ({ data }) => this.getLinkElement(data) },
            { headerName: 'Дата создания', field: 'created_at' },
            { headerName: 'Создан', field: 'created_by_name' },
            { headerName: 'Дата прихода', field: 'date' },
            { headerName: 'Статус операции', field: 'operation_status_name' },
            { headerName: 'Принял', field: 'received_by_name' },
            { headerName: 'Получено у', field: 'received_from_name' },
            { headerName: 'Вид оплаты', field: 'pay_type_name' },
            { headerName: 'Сумма', field: 'amount_formatted' },
            { headerName: 'Статья', field: 'detail_name' },
            { headerName: 'Комментарий', field: 'comment' }
        ];
    },
    beforeMount() {
        this.getIncomes(this.dealId);
    },
    methods: {
        async getIncomes(dealId) {
            const requestParams = {
                size: 1000,
                page: 1,
                sort: [{ colId: 'date', sort: 'desc' }],
                filter: { deal_id: dealId }
            };
            this.loading = true;
            this.$store.dispatch('incomes/getPaginatedList', requestParams).then(
                () => {
                    this.gridOptions.api.setRowData(this.incomes);
                    this.gridOptions.api.sizeColumnsToFit();
                }).finally(() => {
                this.loading = false;
            });
        },
        getRouteForCard(data) {
            const params = { id: '' + data.id };
            if (this.localReferences.payTypesCash.includes(data.pay_type_id)) {
                return { name: 'income-cash-card-view', params };
            }
            if (this.localReferences.payTypesCashless.includes(data.pay_type_id)) {
                return { name: 'income-cashless-card-view', params };
            }
        },
        onSelectionChanged(e) {
            this.$router.push(this.getRouteForCard(e.node.data));
        },
        getLinkElement(data) {
            const route = this.getRouteForCard(data);
            const element = document.createElement('a');
            element.href = this.$router.resolve(route).href;
            element.innerText = data.id;
            element.className += ' spreadsheet-table-id-link';
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        createCashIncome() {
            const params = { id: 'new', dealId: '' + this.dealId };
            this.$router.push({ name: 'income-cash-card', params });
        },
        createCashLessIncome() {
            const params = { id: 'new', dealId: '' + this.dealId };
            this.$router.push({ name: 'income-cashless-card', params });
        }
    }
};
</script>
